var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngularLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 92,
    viewBox: "0 0 88 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.859 2.23336e-05C43.6392 0.00102233 43.4176 0.0373973 43.2066 0.109397L1.34337 14.6797C0.455366 14.9877 -0.100759 15.8746 0.0152412 16.8086L6.63243 71.0547C6.71043 71.6967 7.08977 72.2623 7.65977 72.5703L42.9566 91.7539C43.2526 91.9159 43.5818 91.9961 43.9098 91.9961C44.2398 91.9961 44.5727 91.914 44.8707 91.75L80.3473 72.3047C80.9113 71.9947 81.2947 71.431 81.3707 70.793L87.984 16.5508C88.1 15.6128 87.5382 14.7181 86.6402 14.4141L44.5074 0.101585C44.2974 0.0315848 44.0787 -0.000977666 43.859 2.23336e-05ZM43.9996 9.99612L69.9996 65.9961H61.1246L55.5621 54.0117H32.4371L26.8746 65.9961H17.9996L43.9996 9.99612ZM43.9996 28.9961L36.1598 45.9961H51.8395L43.9996 28.9961Z",
    fill: "#163B6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularLogo);
export default __webpack_public_path__ + "static/media/AngularLogo.bea9c0999888adfeffca42bdca933757.svg";
export { ForwardRef as ReactComponent };